import PropTypes from 'prop-types';
import React from 'react';
import Wrapper from './TooltipWrapper';
import Title from './TooltipTitle';
import Trigger from './TooltipTrigger';

const Tooltip = ({ title, children, disabled, className, preventOverflow }) => (
  <Wrapper preventOverflow={preventOverflow}>
    <Title className={className}>{title}</Title>
    <Trigger disabled={disabled}>{children}</Trigger>
  </Wrapper>
);

Tooltip.defaultProps = {
  disabled: false,
  className: '',
  preventOverflow: false,
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  preventOverflow: PropTypes.bool,
};

export default Tooltip;
